import React, { memo } from 'react';
import t from 'common/i18n';
import DropdownList from 'root/components/DropdownList/DropdownList';
import consts from '../../data/consts';

export const SORT_ITEMS = consts.SORT_OPTIONS.map((value) => ({ label: t(`shutterstock.filters.sort_options.${value}`), value }));

export const getSelectedItem = (value) => SORT_ITEMS.find((item) => item.value === value) || {};

const SortBy = (props) => {
  const selectedItem = getSelectedItem(props.value);

  return (
    <section className={props.className}>
      <label>{t('shutterstock.filters.sort_options.label')}</label>
      <DropdownList className="z-2" items={SORT_ITEMS} selectedItem={selectedItem} onChange={props.setSort} />
    </section>
  );
};

export default memo(SortBy);
